import { Link } from 'react-router-dom';
import { categories } from '@/mocks';

export default function CTASection() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 rounded-2xl overflow-hidden">
          <div className="relative min-h-[300px] md:min-h-[400px] flex items-end">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20entertainment%20news%20explosion%20concept%2C%20digital%20particles%20and%20light%20fragments%2C%20warm%20coral%20and%20red%20tones%2C%20dark%20dramatic%20background%2C%20mysterious%20energy%20burst%2C%20cinematic%20artistic%20rendering&width=800&height=600&seq=cta-left-01&orientation=landscape"
              alt="独家资源集散第一站"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
            <div className="relative z-10 p-6 md:p-10">
              <span className="text-xs text-background-300 font-medium tracking-wider">
                独家渠道
              </span>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-background-50 mt-2 leading-tight">
                全网首发
                <br />
                <span className="text-primary-400">一手猛料</span>
              </h2>
            </div>
          </div>

          <div className="bg-background-50 p-6 md:p-10 flex flex-col items-center justify-center text-center">
            <h3 className="text-xl md:text-2xl font-bold text-foreground-950 mb-3">
              探索更多黑料分类
            </h3>
            <p className="text-sm md:text-base text-foreground-600 max-w-md mb-6 leading-relaxed">
              51吃瓜网站覆盖网红塌房、明星黑料、独家爆料、视频实锤等多个分类频道，
              满足您对娱乐圈内幕的一切好奇心。
            </p>
            <div className="flex flex-wrap justify-center gap-2 mb-6">
              {categories.slice(0, 6).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="px-4 py-2 rounded-full border border-background-200 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 hover:bg-primary-50 transition-all whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
            <Link
              to="/category/jinri-dagua"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-800 text-background-50 text-sm font-medium hover:bg-foreground-900 transition-colors whitespace-nowrap"
            >
              开始吃瓜 <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}